import React from 'react';
import {TextField, TextFieldProps, Typography, Box, styled, InputAdornment} from '@mui/material';

const StyledTextField = styled((props: TextFieldProps) => (
    <TextField {...props} variant="outlined" />
))(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
            borderColor: theme.palette.custom.customBlue,
            borderWidth: 2,
        },
        '&.Mui-focused:hover fieldset': {
            borderColor: theme.palette.custom.customBlue,
            borderWidth: 2,
        },
        '& fieldset': {
            borderColor: theme.palette.custom.customLightGray,
            borderWidth: 1,
        },
        '&:hover fieldset': {
            borderColor: theme.palette.custom.customLightBlue,
            borderWidth: 2,
        }
    },
}));

type TextFieldWithHeaderProps = TextFieldProps & {
    header: string;
    unit?: string;
};

export const TextFieldWithHeader: React.FC<TextFieldWithHeaderProps> = ({ header, unit, ...props }) => {
    return (
        <Box>
            <Typography variant="subtitle1" fontWeight={700}>
                {header}
            </Typography>
            <Box display={"flex"}>
                <StyledTextField
                    fullWidth
                    slotProps={{
                        input: {
                            endAdornment: unit ? (
                                <InputAdornment position="end">
                                    <Typography>
                                        {unit}
                                    </Typography>
                                </InputAdornment>
                            ) : undefined,
                        },
                    }}
                    {...props}
                />
            </Box>
        </Box>
    );
};